import { EditBookModal } from './EditBookModal';
import { DeleteBookModal } from './DeleteBookModal';
import { ListModal } from './ListModal';
import { AddToCollectionModal } from './AddToCollectionModal';
import { RescopeSavedResponseModal } from './RescopeSavedResponseModal';
import { DeleteVideoModal } from './DeleteVideoModal';
import { DeleteVideoGroupModal } from './DeleteVideoGroupModal';
import { AddToVideoGroupModal } from './AddToVideoGroupModal';
import { useModalStore } from '../../store/modalStore';
import type { ReadingList } from '../../types/models';

export function ModalContainer() {
  const { modalType, modalData } = useModalStore();

  return (
    <>
      <EditBookModal />
      <DeleteBookModal />
      <AddToCollectionModal />
      <RescopeSavedResponseModal />
      <DeleteVideoModal />
      <DeleteVideoGroupModal />
      <AddToVideoGroupModal />
      {(modalType === 'createList' || modalType === 'editList') && (
        <ListModal list={modalData as ReadingList | null} />
      )}
    </>
  );
}
